import {
    getOutdoorBarArticleCardsByCategoryUid,
    GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema,
} from './get-outdoor-bar-article-cards-by-category-uid';
import {
    getOutdoorBarArticleCategories,
    GetOutdoorBarArticleCategoriesApiResponseSchema,
} from './get-outdoor-bar-article-categories';
import {
    getOutdoorBarsService,
    GetOutdoorBarsServiceActionResponseMapper,
} from './get-outdoor-bars-service';

export {
    GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema,
    GetOutdoorBarArticleCategoriesApiResponseSchema,
    GetOutdoorBarsServiceActionResponseMapper,
};

export const OutdoorBarsPageActions = {
    getOutdoorBarArticleCardsByCategoryUid,
    getOutdoorBarArticleCategories,
    getOutdoorBarsService,
};
